"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
function ServerError() {
    const history = (0, react_router_dom_1.useHistory)();
    return ((0, jsx_runtime_1.jsx)("div", { className: "page-container centered-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "error-page-container", children: [(0, jsx_runtime_1.jsx)(Error_1.default, { style: { fontSize: 100 }, color: "disabled" }), (0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: "Oops! Something went wrong!" }), (0, jsx_runtime_1.jsxs)("p", { className: "error-page-paragraph", children: ["Please contact our hotline to let us know what you were trying to accomplish at \u00A0", config_1.ALPHAEON_CONTACT_PHONE, "."] }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { className: "button-warn-outline", onClick: () => history.goBack(), children: "Retry Request" })] }) }));
}
exports.default = (0, react_1.memo)(ServerError);
